import { useFormContext } from "react-hook-form";

import Input from "~/components/ui/input/Input.tsx";
import { useTeam } from "~/contexts/TeamProvider.tsx";
import { canMember } from "~/helpers/authorizations";

import FormLabel from "../login/formLabel/FormLabel";
import styles from "./Settings.module.scss";

export const TeamCrawlerSettings = () => {
  const { authorizations: teamAuthorizations } = useTeam();
  const canUpdateTeam = canMember(teamAuthorizations, "update");
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles.settingsTeamForm}>
      <div className={styles.settingsSwitchGroup}>
        <div>
          <FormLabel label="Custom bot name to use in the Crawler's user agent string" />
          <Input
            disabled={!canUpdateTeam}
            errormessage={
              errors.custom_bot_name
                ? errors.custom_bot_name?.message?.toString()
                : ""
            }
            {...register("custom_bot_name", {
              required: false,
            })}
            placeholder="AlliAI/1.0"
          />
        </div>
      </div>
    </div>
  );
};
